<template>
  <div class="codeblock-tabbed">
    <div>
      <div
        class="tabs"
        role="tablist"
      >
        <button
          v-for="tabName in tabNames"
          :key="tabName"
          class="tab"
          type="button"
          role="tab"
          :aria-controls="tabName"
          :aria-selected="selected == tabName"
          @click.prevent="() => select(tabName)"
        >
          {{ tabName }}
        </button>
      </div>
    </div>

    <div :id="selected">
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CodeBlock-TabSet',

    data() {
      return {
        tabs: [],
        selected: null
      }
    },

    computed: {
      tabNames() {
        return this.tabs.map((c) => {
          return c.name
        })
      }
    },

    created() {
      this.tabs = this.$children
    },

    updated() {
      this.updateTabs()
    },

    methods: {
      select(tabName) {
        this.selected = tabName
        this.updateTabs()
      },

      updateTabs() {
        if (this.tabs.length > 0) {
          this.tabs.forEach((tab) => {
            tab.isVisible = false
          })

          if (this.selected === null) {
            this.selected = this.tabNames[0]
          }

          this.tabs.find((tab) => {
            if (tab.name === this.selected) {
              tab.isVisible = true
            }
          })
        }
      }
    }
  }
</script>
